import { redirect } from '@hooks'
import { createFileRoute } from '@tanstack/react-router'

const ReportsRedirect = redirect('/stats/')

export const Route = createFileRoute('/reports/')({
  component: ReportsRedirect,
})
